import { useEffect, useState } from "react";

const TARGET = new Date("2026-10-30T14:30:00+10:00").getTime(); // 2:30 PM Toowoomba (AEST)

function diff() {
  const now = Date.now();
  const ms = Math.max(0, TARGET - now);
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return { days, hours, minutes, seconds, done: ms === 0 };
}

export default function Countdown() {
  const [t, setT] = useState(diff());

  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return (
      <div
        className="italic text-[#76232F] text-5xl md:text-6xl text-center"
        style={{ fontFamily: "'Pinyon Script', cursive" }}
      >
        Today is the day.
      </div>
    );
  }

  const units = [
    { n: t.days, label: "Days" },
    { n: t.hours, label: "Hrs" },
    { n: t.minutes, label: "Min" },
    { n: t.seconds, label: "Sec" },
  ];

  return (
    <div className="w-full" data-testid="countdown">
      <div
        className="flex items-baseline justify-center"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {units.map((u, i) => (
          <div key={u.label} className="flex items-baseline">
            <div className="flex flex-col items-center">
              <div className="text-[#76232F] font-bold leading-none text-[15px] tabular-nums">
                {String(u.n).padStart(2, "0")}
              </div>
              <div className="mt-1 text-[10px] uppercase tracking-[0.28em] text-[#76232F]/60">
                {u.label}
              </div>
            </div>
            {i < units.length - 1 && (
              <div
                aria-hidden="true"
                className="text-[#76232F]/40 font-light leading-none text-[15px] mx-3"
              >
                :
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
